import { render } from "./batchUpdateClockDistance.vue?vue&type=template&id=96d5de9a&scoped=true"
import script from "./batchUpdateClockDistance.vue?vue&type=script&lang=js"
export * from "./batchUpdateClockDistance.vue?vue&type=script&lang=js"

import "./batchUpdateClockDistance.vue?vue&type=style&index=0&id=96d5de9a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d5de9a"]])

export default __exports__